import imgAiBlockBg from './img/ai对话区背景.png'
import imgAiChatBlockBg from './img/ai对话框背景.png'
import imgAiAssistant from './img/ai助手.png'
import imgAiTabDeepSeek from './img/ai-tab-deepseek.png'
import imgAiTabDeepSeekActive from './img/ai-tab-deepseek -active.png'
import imgAiMoreArrowRight from './img/ai更多功能-进入.png'
import imgAiChatAvatar from './img/ai-chat-avatar.png'
import imgAiBtnChatSend from './img/ai-btn-chat-send.png'
import imgAiThinking from './img/ai-思考中.png'
import imgAiThinkingArrowUp from './img/ai-思考中-arrow-up.png'
import imgAiThinkingArrowDown from './img/ai-思考中-arrow-down.png'
import imgIconDeepseekScroll from './img/ai-icon-deepseek-scroll.png'

import css from './blockAi.module.scss'

import {observer} from "mobx-react";

import {MutableRefObject, Ref, useEffect, useRef} from "react";
// import AiTypeEnum from "enum/AiTypeEnum.js";
import classNames from "classnames";
import aiApi from "@/ai-api";
// import AiMessageRoleEnum from "enum/AiMessageRoleEnum.js";
import {autorun, makeAutoObservable, observable, reaction, when} from "mobx";
import {AiMessageRoleEnum, AiModelEnum, AiUtilTypeEnum} from "@/ai-api/type-ai";
import {TextForm} from "@/ai-api/aiApi";
import {HistoryTextDtoPartial, HistoryTextPageForm} from "@/ai-api/historyTextApi";
import AiAuthUtil from "@/utils/AiAuthUtil";
import {AiConfig} from "@/ai-api/aiConfigApi";
import {message} from "antd";
import useIFrameMessage from "@/hooks/useIFrameMessage";
import {closeAiChatPlugin, openAiChatPanel} from "@/utils/IFrameUtil";
import {DateTime, Duration} from 'luxon'
import {useKeyPress} from "ahooks";


type Tab = {
    value: AiModelEnum
    label: string
    name: string
}

const tabList = [
    {
        value: AiModelEnum.DeepSeek,
        label: 'Deep Seek',
        name: 'DeepSeek',
    },
    {
        value: AiModelEnum.DeepSeekThinking,
        label: 'Deep Seek 深度思考',
        name: 'DeepSeek',
    }
]

class AiStore {

    tabValue: Tab['value'] = tabList[0].value
    inputValue: string = ''
    currentEventSource: EventSource | undefined = undefined

    thinking: boolean = false
    showReasoning: boolean = true
    thinkingStartTime: DateTime | undefined = undefined
    thinkingDuration: number = 0
    thinkingDurationIntervalId: number | undefined = undefined

    iconDeepseekFlag: boolean = false;

    showIconDeepseek() {
        this.iconDeepseekFlag = true
    }

    hideIconDeepseek() {
        this.iconDeepseekFlag = false
    }

    toggleShowReasoning() {
        this.showReasoning = !this.showReasoning
    }

    get thinkingDurationFormat() {
        if (this.thinkingDuration === 0) {
            return ''
        }

        const duration = Duration.fromObject({
            second: this.thinkingDuration
        }).shiftTo('minutes', 'seconds')
        const durationObject = duration.toObject()
        let str = ''
        if (durationObject.minutes) {
            str += `${durationObject.minutes}分`
        }
        str += `${durationObject.seconds}秒`

        return str
    }

    get isDeepThink() {
        return this.tabValue === AiModelEnum.DeepSeekThinking
    }

    eventSourceLoading: boolean = false

    resetSse() {
        this.thinking = false
        this.showReasoning = true
        this.thinkingStartTime = undefined
        this.thinkingDuration = 0
        this.thinkingDurationIntervalId = undefined
        this.eventSourceLoading = false
    }

    // messageList = []

    historyTextList: HistoryTextDtoPartial[] = []

    curHistoryText: HistoryTextDtoPartial | undefined = undefined

    get allHistoryTextList() {
        let arr = this.historyTextList
        if (this.curHistoryText) {
            arr = [...arr, this.curHistoryText]
        }

        return arr
    }

    curReasoning: string = ''
    curContent: string = ''

    resetCurHistoryText() {
        if (!this.curHistoryText) {
            return
        }
        this.historyTextList.push(this.curHistoryText)
        this.curHistoryText = undefined
        this.curReasoning = ''
        this.curContent = ''
    }

    async fetchHistoryTextList(params: Pick<HistoryTextPageForm, 'model'>) {
        const glxResult = await aiApi.historyText
            .recentList({
                ...params,
                // ai首页只有聊天
                utilType: AiUtilTypeEnum.TextDefault,
                clientId: AiAuthUtil.getClientId()
            })
        this.historyTextList = glxResult.data
    }

    valueToTabMap = new Map(
        tabList.map(item => [item.value, item])
    )

    get tab() {
        return this.valueToTabMap.get(this.tabValue)
    }

    // get lastMessage() {
    //     return this.messageList[this.messageList.length - 1]
    // }

    // initMessageList(list) {
    //     this.messageList = list
    // }

    setTabValue(value: Tab['value']) {
        if (value === this.tabValue) {
            return;
        }
        if (this.eventSourceLoading) {
            return;
        }

        this.tabValue = value
    }

    setCurrentEventSource(value: EventSource) {
        this.closeCurrentEventSource()
        this.currentEventSource = value
    }

    closeCurrentEventSource() {
        this.currentEventSource?.close()
    }


    online(): boolean {
        return !!AiAuthUtil.getToken()
    }

    get btnSendEnable() {
        return this.online() && !this.eventSourceLoading;
    }


    async sendMessage(params: Pick<TextForm, 'model' | 'content'>) {
        if (!this.btnSendEnable || !params.content) {
            return
        }

        if (
            this.currentEventSource &&
            this.currentEventSource.readyState !== EventSource.CLOSED
        ) {
            return
        }

        this.resetCurHistoryText()
        this.curHistoryText = {
            round: {
                question: {
                    role: AiMessageRoleEnum.User,
                    content: params.content
                },
                answer: {
                    role: AiMessageRoleEnum.System,
                    reasoning: '',
                    content: ''
                }
            }
        }

        const eventSource = await aiApi.ai.text({
            ...params,
            // ai商城只有聊天，没有模拟和创作
            utilType: AiUtilTypeEnum.TextDefault,
            role: AiMessageRoleEnum.User,
            onOpen: () => {
                this.eventSourceLoading = true
                this.thinking = true
            },
            onMessage: (chatResult) => {
                const {reasoning, content} = chatResult

                if (this.thinking && content) {
                    this.thinking = false
                }

                if (reasoning) {
                    this.curReasoning = `${this.curReasoning}${reasoning}`
                } else if (content) {
                    this.curContent = `${this.curContent}${content}`
                }
            },
            onEnd: () => {
                this.resetCurHistoryText()
                this.resetSse()
            },
            onError: (errMsg) => {
                this.resetCurHistoryText()
                this.resetSse()
            }
        })

        this.setCurrentEventSource(eventSource)
    }


    resetInputValue() {
        this.inputValue = ''
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const aiStore = new AiStore()
reaction(() => aiStore.thinking, (curThinking, prevThinking) => {
    if (!prevThinking && curThinking) {
        aiStore.thinkingStartTime = DateTime.local()

        aiStore.thinkingDurationIntervalId = window.setInterval(() => {
            if (!aiStore.thinkingStartTime) {
                return
            }

            aiStore.thinkingDuration = aiStore.thinkingDuration + 1
        }, 1000)
    } else if (prevThinking && !curThinking) {
        if (aiStore.thinkingDurationIntervalId) {
            clearInterval(aiStore.thinkingDurationIntervalId)
            aiStore.thinkingStartTime = undefined
        }
    }
})

/*
* 当前reasoning
* */
reaction(
    () => aiStore.curReasoning,
    (curValue) => {
        if (!curValue) {
            return
        }

        const answer = aiStore.curHistoryText?.round.answer
        if (!answer) {
            return
        }

        answer.reasoning = curValue
    }
)

/*
* 当前content
* */
reaction(
    () => aiStore.curContent,
    (curValue) => {
        if (!curValue) {
            return
        }

        const answer = aiStore.curHistoryText?.round.answer
        if (!answer) {
            return
        }

        answer.content = curValue
    }
)

/*
* tab变化，需要重新请求历史列表
* */
reaction(() => aiStore.tabValue, (newTabValue, oldTabValue) => {
    if (newTabValue === oldTabValue) {
        return
    }

    aiStore.fetchHistoryTextList({model: newTabValue}).then(() => {
        aiStore.resetCurHistoryText()
    })
})

// todo自动运行一次获取历史记录
when(() => true, () => {
    aiStore.fetchHistoryTextList({model: aiStore.tabValue}).then(() => {
        aiStore.resetCurHistoryText()
    })
})

export type Props = {
    aiConfig: AiConfig
    scrollToAiBlock: () => void
}

const Index = ({aiConfig, scrollToAiBlock}: Props) => {
    const inputRef = useRef<HTMLInputElement>(null)

    const onClickMoreFunction = () => {
        openAiChatPanel()
    }

    const sendMessage = async () => {
        await aiStore.sendMessage({
            content: aiStore.inputValue,
            model: aiStore.tabValue,
        })
        aiStore.resetInputValue()
    }

    useKeyPress(
        'enter',
        (event: any) => {
            sendMessage().then()
        },
        {
            target: inputRef,
        },
    );

    // iframe 事件监听
    useIFrameMessage({
        onLogin: (data) => {
            AiAuthUtil.setClientId(data.clientId)
            AiAuthUtil.setToken(data.token)

            aiStore.fetchHistoryTextList({model: aiStore.tabValue}).then()
        },
        // onClose: () => {
        //     closeAiChatPlugin()
        // }
    })


    return (
        <div className={css.blockAi}>
            {/* container */}
            <div className={css.blockAiContainer}>
                <img src={imgAiBlockBg} className={css.bgBlockAi} alt=""/>
                {/* ai框 */}
                <div className={css.chatBlock}>
                    {/* 背景 */}
                    <img src={imgAiChatBlockBg} className={css.bgChatBlock} alt=""/>

                    {/* tab floor */}
                    <div className={css.tabFloor}>
                        {/* ai助手图标 */}
                        <img className={css.iconAiAssistant} src={imgAiAssistant} alt=""/>

                        {/* tab列表 */}
                        {
                            tabList.map((item, index) => {
                                const isFirst = index === 0;
                                const active = item.value === aiStore.tabValue
                                return (
                                    <div
                                        key={item.value}
                                        className={classNames(css.tab, {[css.notFirst]: !isFirst})}
                                        onClick={() => {
                                            aiStore.setTabValue(item.value)
                                        }}
                                    >
                                        {
                                            active
                                                ? <img className={css.icon}
                                                       src={imgAiTabDeepSeekActive}
                                                       alt=""/>
                                                : <img className={css.icon}
                                                       src={imgAiTabDeepSeek}
                                                       alt=""/>
                                        }
                                        <span className={classNames(css.label, {[css.active]: active})}>
                                            {item.label}
                                        </span>

                                        {
                                            active && <div className={css.bgActive}></div>
                                        }
                                    </div>
                                )
                            })
                        }

                        {/* 更多功能按钮 */}
                        <button
                            className={css.btnMoreFunction}
                            onClick={onClickMoreFunction}
                        >
                            <span className={css.text}>更多功能</span>
                            <img className={css.iconArrowRight} src={imgAiMoreArrowRight}
                                 alt=""/>
                        </button>
                    </div>
                    {/* message block */}
                    <div className={css.historyTextBlock}>
                        <div className={classNames(css.historyTextList)}>
                            {
                                aiStore.allHistoryTextList.length === 0 &&
                                <div className={css.messageFloor}>
                                    <div className={css.messageHello}>

                                        <img className={css.iconAvatar} src={imgAiChatAvatar} alt=""/>


                                        <div className={css.messageContainer}>

                                            <div className={css.messageWrapper}>
                                                <div
                                                    className={css.content}>
                                                    <p className={css.title}>嗨！我是 DeepSeek</p>
                                                    <p className={css.content}>我可以帮你搜索、答疑、写作，请把你的任务交给我吧~</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                aiStore.allHistoryTextList.slice().reverse().map((historyText, index) => {
                                    const msgQuestion = historyText.round.question
                                    const msgAnswer = historyText.round.answer

                                    const isFirst = index === 0;
                                    const isLast = index === aiStore.allHistoryTextList.length - 1;

                                    return (
                                        <div key={index}
                                             className={classNames(css.messageFloor, {[css.notLast]: !isLast})}>


                                            <div className={css.messageUser}>
                                                <div
                                                    className={css.messageContainer}>
                                                    <div className={css.content}>
                                                        {msgQuestion.content}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={css.messageSystem}>
                                                <img className={css.iconAvatar} src={imgAiChatAvatar} alt=""/>
                                                <div className={css.messageContainer}>
                                                    {/*思考中*/}
                                                    {
                                                        0 === index && aiStore.thinking &&
                                                        <div className={css.thinkingFloor}>
                                                            <div className={css.thinking}>
                                                                <img className={css.icon}
                                                                     src={imgAiThinking} alt=""/>
                                                                <span className={css.text}>思考中...</span>
                                                            </div>
                                                            {
                                                                aiStore.isDeepThink &&
                                                                <div
                                                                    className={css.thinkingDuration}
                                                                    onClick={() => {
                                                                        aiStore.toggleShowReasoning()
                                                                    }}
                                                                >
                                                                    <img className={css.icon} src={imgAiThinking}
                                                                         alt=""/>
                                                                    <span
                                                                        className={css.text}>已深度思考(用时{aiStore.thinkingDurationFormat})</span>
                                                                    {
                                                                        aiStore.showReasoning ?
                                                                            <img
                                                                                className={css.iconArrow}
                                                                                src={imgAiThinkingArrowUp}
                                                                                alt=""
                                                                            /> :
                                                                            <img
                                                                                className={css.iconArrow}
                                                                                src={imgAiThinkingArrowDown}
                                                                                alt=""
                                                                            />
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                    <div className={css.messageWrapper}>
                                                        {
                                                            msgAnswer?.reasoning && !(
                                                                0 === index &&
                                                                !aiStore.showReasoning
                                                            ) &&
                                                            <div
                                                                className={css.reasoning}>
                                                                {msgAnswer?.reasoning}
                                                            </div>
                                                        }
                                                        <div
                                                            className={css.content}>
                                                            <p>
                                                                {msgAnswer?.content}
                                                            </p>
                                                            <div className={css.tipWrapper}>
                                                                <em>内容由AI生成，仅供参考</em>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    {/* input floor */}
                    <div
                        className={css.inputBlock}>
                        <input ref={inputRef} type="text" placeholder={`给${aiStore.tab?.name}发送信息`}
                               value={aiStore.inputValue}
                               onChange={(e) => {
                                   aiStore.inputValue = e.target.value
                               }}
                        />
                        <button
                            className={css.btnSend}
                            style={{
                                backgroundImage: `url(${imgAiBtnChatSend})`,
                            }}
                            onClick={sendMessage}
                        >
                        </button>
                    </div>
                </div>
            </div>

            {/* DeepSeek 悬浮图标 */}
            <div className={css.iconScrollToDeepSeekBlock}>
                <button className={css.btnIcon} onClick={scrollToAiBlock}>
                    <img className={css.icon} src={imgIconDeepseekScroll} alt=""/>
                </button>
            </div>
        </div>
    )
}

export default observer(Index)